module.exports = __webpack_public_path__ + "img/wt56.568717d4.png";